import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {withApollo} from "react-apollo";

import withStyles from "material-ui/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class ExportUsersModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let title = "Export Users?";

    if (this.props.title)
      title = this.props.title;

    return(
        <SweetAlert
          onConfirm={(evt) => this.props.onDownloadButtonConfirm(evt)}
          onCancel={() => this.props.onDownloadButtonCancel()} 
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Export"
          cancelBtnText="Cancel"
          showCancel
          title={title}
          style={{overflow: "visible !important"}}
        >
        </SweetAlert>
    )
  }
}

export default  withStyles(sweetAlertStyle)((withApollo(ExportUsersModal)));


// WEBPACK FOOTER //
// ./src/views/users/components/ExportUsersModal.js